import request from 'utils/request';

export default async function fetchDistributors(): Promise<any> {
  try {
    const { data: result } = await request(
      `/lineDriveService/masterData/distributor`,
      {
        method: 'GET'
      }
    );

    return result;
  } catch (error) {
    console.log(error.message);
  }
}
